import React from "react";
import { SelectedProductContext, SelectedProductType } from "./context";
import Product from "../../../../utilities/data/model/Product";

export const useSelectedProduct = (): SelectedProductType => {
  const [product, _setSelectedProduct] = React.useState<Product | undefined>(
    undefined
  );

  const setProduct = React.useCallback(
    (product: Product | undefined) => {
      _setSelectedProduct(product);
    },
    [_setSelectedProduct]
  );

  return {
    product,
    setProduct,
  };
};
export const useSelectedProductContextProvider = () => {
  const context = React.useContext(SelectedProductContext);
  if (!context) {
    throw new Error("No SelectedProductContext context was provided.");
  }
  return context;
};
